// extracted by mini-css-extract-plugin
var _1 = "FloatingInput-module__floating_label__Wo8Ua";
var _2 = "FloatingInput-module__input___0d7D";
export { _1 as "floating_label", _2 as "input" }
